import * as React from 'react'
import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default'
import * as $ from 'jquery';
import promiseFor from '../../util/promise-for';
import { GALLERY_HINH } from './util';

export default class HinhDetail extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            loading: false
        }
    }

    /**
     * @author Bình
     * khi mở gallery thì nạp albuml vô đây
     */
    componentDidMount() {
        if (this.props.images && this.props.images.length > 0) {
            // GALLERY_HINH.getSizeImage(this.props.images, this.props.tieu_de).then(img => {
            // let img = GALLERY_HINH.getSizeImage(this.props.images, this.props.tieu_de);

            let pswpElement: any = document.querySelectorAll('.pswp')[0];

            // define options (if needed)
            let options = {
                // optionName: 'option value'
                // for example:
                index: 0 // start at first slide
            };

            // Initializes and opens PhotoSwipe
            var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, this.props.images, options);

            /**
             * khởi tạo gallery
             */
            gallery.init();

            /**
             * lắng nghe sự kiện đóng lại
             */
            gallery.listen('close', () => {
                this.props.close(true)
            });
            // })
        }

    }

    render() {
        return (
            <React.Fragment>
                {/* khung dựng chứa hình */}
                <div className="pswp" tabIndex={-1} role="dialog" aria-hidden="true">


                    <div className="pswp__bg"></div>

                    <div className="pswp__scroll-wrap">


                        <div className="pswp__container">
                            <div className="pswp__item"></div>
                            <div className="pswp__item"></div>
                            <div className="pswp__item"></div>
                        </div>

                        <div className="pswp__ui pswp__ui--hidden">

                            <div className="pswp__top-bar">


                                <div className="pswp__counter"></div>

                                <button className="pswp__button pswp__button--close" title="Close (Esc)"></button>

                                <button className="pswp__button pswp__button--share" title="Share"></button>

                                <button className="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>

                                <button className="pswp__button pswp__button--zoom" title="Zoom in/out"></button>


                                <div className="pswp__preloader">
                                    <div className="pswp__preloader__icn">
                                        <div className="pswp__preloader__cut">
                                            <div className="pswp__preloader__donut"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
                                <div className="pswp__share-tooltip"></div>
                            </div>

                            <button className="pswp__button pswp__button--arrow--left" title="Previous (arrow left)">
                            </button>

                            <button className="pswp__button pswp__button--arrow--right" title="Next (arrow right)">
                            </button>

                            <div className="pswp__caption">
                                <div className="pswp__caption__center"></div>
                            </div>

                        </div>

                    </div>

                </div>

            </React.Fragment >
        )
    }
}
